module.exports = __webpack_public_path__ + "img/128.3.55ffbc42.png";